export const COUNTRIES = [
    "United States", "India", "United Kingdom", "Canada", "Australia",
    "Germany", "France", "Japan", "Brazil", "Mexico", "Singapore",
    "United Arab Emirates", "South Africa", "Nigeria", "Kenya",
    "Indonesia", "Pakistan", "Bangladesh", "Philippines", "Vietnam",
    "Thailand", "Malaysia", "Turkey", "Saudi Arabia", "Egypt",
    "Italy", "Spain", "Netherlands", "Sweden", "Norway",
    "Denmark", "Finland", "Poland", "Russia", "Ukraine",
    "Argentina", "Chile", "Colombia", "Peru", "New Zealand",
    "Ireland", "Switzerland", "Belgium", "Portugal", "Greece",
    "Hong Kong", "South Korea", "Taiwan", "Israel", "Other",
];
